import { useCallback, useEffect, useState } from 'react';

import Fab from '@mui/material/Fab';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function handleClickBackToTop() {
  window.scroll({ behavior: 'smooth', top: 0 });
}

function BackToTop() {
  const [isBackToTopVisible, setIsBackToTopVisible] = useState(false);

  const toggleButtonVisibilityOnScroll = useCallback(() => {
    const shouldBackToTopGetVisible = window.scrollY > document.documentElement.clientHeight;
    if (isBackToTopVisible !== shouldBackToTopGetVisible)
      setIsBackToTopVisible(shouldBackToTopGetVisible);
  }, [isBackToTopVisible]);

  useEffect(() => {
    window.addEventListener('scroll', toggleButtonVisibilityOnScroll);
    return () => {
      window.removeEventListener('scroll', toggleButtonVisibilityOnScroll);
    };
  }, [toggleButtonVisibilityOnScroll]);

  if (isBackToTopVisible === false) return null;

  return (
    <Fab
      aria-label='Back To Top'
      onClick={handleClickBackToTop}
      sx={({ palette }) => ({
        zIndex: 100,
        position: 'fixed',
        bottom: '1.5rem',
        right: '1.5rem',
        bgcolor: palette.primary.main,
        color: '#fff',
        boxShadow: '0 6px 20px rgba(1, 64, 79, 0.28)',
        transition: 'background-color .2s ease, transform .15s ease',
        '&:hover': {
          bgcolor: palette.primary.dark,
          transform: 'translateY(-2px)',
        },
      })}>
      <KeyboardArrowUpIcon fontSize='medium' />
    </Fab>
  );
}

export default BackToTop;
